/**
 *
 * FBMobileWrapper
 *
 */

import React from 'react';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

// styles
import './style.scss';

// layout components
// import ErrorBoundary from 'engine/ErrorBoundary';
// import Preloader from 'components/Preloader';
import { Switch } from 'antd';


function SwitchOnCancelAll({
  name,
  checked,
  loading,
  disabled,
  onChange,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('tcf-fb-appointment-cansel-switcher', className);
  const { t } = useTranslation();

  const onHandleChange = (checked) => {
    !!onChange && onChange(checked);
  };

  return (
    <div {...rest} className={childClassNames}>
      <Switch key={name} name={name} loading={loading} disabled={disabled} checked={checked} onChange={onHandleChange} />
      {t("news.noneDatesSuit")}
    </div>
  );
}

SwitchOnCancelAll.defaultProps = {
  name: "cancelAllOptions",
  loading: false,
  disabled: false,
  checked: false,
};

export default SwitchOnCancelAll;
